import GreenPlusButton from "components/Buttons/GreenPlusButton";
import { de } from "date-fns/locale";
import React from "react";
import { Table, Label, Icon } from "semantic-ui-react";
import { getFormattedTimeFromSeconds, formatDateAndTime } from "utils/dateUtils";

const SupportedFoldersContent = ({ supportedFolders, secretary, onClose }) => {
	const formatStatusToDisplay = (status) => {
		switch (status) {
			case "REASSIGNED":
				return "Validé";
			case "CANCELEDBYSEC":
				return "Annulé";
			case "PENDING":
				return "En attente";
			default:
				return status;
		}
	};
	const colorStatus = (status) => {
		switch (status) {
			case "REASSIGNED":
				return "green";
			case "CANCELEDBYSEC":
				return "black";
			case "PENDING":
				return "grey";
			default:
				return "blue";
		}
	};
	return (
		<div style={{ maxHeight: "400px", overflowY: "auto" }}>
			<Icon name="close" style={{ float: "right", cursor: "pointer" }} onClick={onClose} />
			<h4>
				Dossiers traités par {secretary} - {supportedFolders ? getFormattedTimeFromSeconds(supportedFolders.timeInSec) : ""}
			</h4>
			{!supportedFolders && <div>Chargement...</div>}

			{supportedFolders && (
				<Table basic="very" celled>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Dossier</Table.HeaderCell>
							<Table.HeaderCell>Temps passé</Table.HeaderCell>
							<Table.HeaderCell>À partir de</Table.HeaderCell>
							<Table.HeaderCell>Jusqu'à</Table.HeaderCell>
							<Table.HeaderCell>Statut</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{supportedFolders.data?.map((data) => (
							<Table.Row key={`sec-folder-${data.folderCode}`}>
								<Table.Cell>{data.folderCode}</Table.Cell>
								<Table.Cell>{getFormattedTimeFromSeconds(data.timeSpend)}</Table.Cell>
								<Table.Cell>{formatDateAndTime(data.started)}</Table.Cell>
								<Table.Cell>{formatDateAndTime(data.ended)}</Table.Cell>
								<Table.Cell>
									<Label color={colorStatus(data.statusTo)}>{formatStatusToDisplay(data.statusTo)}</Label>
								</Table.Cell>
							</Table.Row>
						))}
					</Table.Body>
				</Table>
			)}
		</div>
	);
};

export default SupportedFoldersContent;
